module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Orbe-18aacb1c8ae83976b1e3a434f6756621.svg";